<template>
  <div><dlrzck /></div>
</template>

<script>
// 获取接口地址
import dlrzck from '@/components/rizhi/dlrz'

export default {
  name: 'Dlrz',
  components: {
    // sideMenu,
    // Header
    dlrzck
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
